/** Only the first Stage 2 -> Stage 3 transition starts discovery automatically. */
export const shouldArmFirstProductDiscoveryEntry = (
  flowId: string | null | undefined,
  maxStageReached: number,
): boolean => Boolean(flowId && maxStageReached < 2);
